module.exports = __webpack_public_path__ + "img/IMG_9512_L_Foamcore.3eccf187.jpg";